import { useMutation } from '@apollo/react-hooks';
import gql from 'graphql-tag';
import { updateCacheByType } from '../../../graphql/GraphQlProvider';
import { ResourceOption } from '../../../graphql/resources.datatypes';
import { gqlResourceOption } from '../getResourceOption.api';

interface CloneResourceOptionVars {
  id: number,
}

interface CloneResourceOptionData {
  cloneResourceOption: ResourceOption
}

export const CLONE_RESOURCE_OPTION_MUTATION = gql`
    mutation cloneResourceOption($id: Int!){
        cloneResourceOption(id: $id){
          ${gqlResourceOption}
        }
    }
`;

export const cloneResourceOption = () => useMutation<CloneResourceOptionData, CloneResourceOptionVars>(
  CLONE_RESOURCE_OPTION_MUTATION,
  {
    update: updateCacheByType('ResourceOption'),
  }
);

export default cloneResourceOption;